import { render, staticRenderFns } from "./DashFees.vue?vue&type=template&id=5458a84f&scoped=true&"
import script from "./DashFees.vue?vue&type=script&lang=js&"
export * from "./DashFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5458a84f",
  null
  
)

export default component.exports